/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from '@bottlebooks/gatsby-design-system/src/components/icons/sizes';

/**
 * An icon showing up.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function YoutubeIcon({ className, size = 'xsmall', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      {...rest}
      viewBox="0 0 300 300"
    >
      <g transform="scale(.75)">
        <rect width={400} height={400} ry={200} fill="currentColor" />
        <path
          d="M199.917 105.63s-84.292 0-105.448 5.498c-11.328 3.165-20.655 12.492-23.82 23.987-5.498 21.156-5.498 64.968-5.498 64.968s0 43.98 5.497 64.802c3.166 11.495 12.326 20.656 23.82 23.82 21.323 5.665 105.449 5.665 105.449 5.665s84.459 0 105.614-5.498c11.495-3.165 20.655-12.16 23.654-23.82 5.664-20.99 5.664-64.802 5.664-64.802s.166-43.98-5.664-65.135c-2.999-11.495-12.16-20.655-23.654-23.654-21.155-5.83-105.614-5.83-105.614-5.83zm-26.82 53.974l70.132 40.48-70.133 40.312v-80.792z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
